module.exports = __webpack_public_path__ + "fonts/NotoSans-Thin.91454b5.ttf";